module.exports = __webpack_public_path__ + "static/media/animation.35507380.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation.gif
// module id = 2082
// module chunks = 0